<template>
  <div :class="`padding-right-${spacing}`">
    <fade-transition>
      <div v-show="roleData.show" @click="setCollapse" class="roles__item">
        <div class="roles__right-box">
          <span class="roles__right-icon">
            <mdicon :name="`chevron-${collapse ? 'down' : 'left'}`" size="24" />
          </span>
          <span class="roles__text">
            {{ roleData.caption }}
          </span>
        </div>
        <div class="roles__left-box">
          <span v-if="selectable" class="roles__checkbox">
            <b-form-checkbox @change="handleSelect" size="lg" />
          </span>
          <span v-else class="roles__left-icon">
            <mdicon name="dots-vertical" size="24" />
          </span>
        </div>
      </div>
    </fade-transition>
    <collapse-transition>
      <div v-if="hasChildren && collapse" class="roles__items">
        <Roles
          v-for="(childData, index) in roleData.children"
          :key="`a-${index}`"
          :roleData="childData"
          :selectable="selectable"
          :spacing="20"
        />
      </div>
    </collapse-transition>
  </div>
</template>

<script>
import Roles from "./Roles.vue";
import { pathOr } from "ramda";
import { computed, inject, ref, toRefs } from "vue";

export default {
  name: "Roles",
  components: { Roles },
  props: {
    roleData: {
      type: Object,
      default: null,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    spacing: {
      type: Number,
      default: 0,
    },
  },
  methods: { pathOr },
  setup(props, { emit }) {
    // generate props data
    const { roleData, selectable, spacing } = toRefs(props);

    const hasChildren = computed(() => {
      const { children } = roleData.value;
      return children.length;
    });
    const collapse = ref(true);
    const setCollapse = () => (collapse.value = !collapse.value);

    // select a role
    const handleRoleSelect = inject("handleRoleSelect");
    const handleSelect = (selected) => {
      const { code, caption } = roleData.value;
      handleRoleSelect(selected, { code, caption });
    };

    return {
      roleData,
      selectable,
      spacing,
      hasChildren,
      collapse,
      setCollapse,
      handleSelect,
    };
  },
};
</script>
